import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "user-profile-menu__user" }
const _hoisted_2 = { class: "user-profile-menu__user-data" }
const _hoisted_3 = { class: "user-profile-menu__user-display-name" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "user-profile-menu__items" }
const _hoisted_7 = {
  key: 0,
  class: "user-profile-menu__items-group"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "user-profile-menu__items-tasks" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "cwx-icon cwx-icon-before_information-default"
}
const _hoisted_16 = { key: 3 }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "user-profile-menu__items-group" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  action: "/account/logoff",
  method: "post"
}
const _hoisted_25 = { type: "submit" }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = ["href"]

import { useAppStore } from '@/stores/app.store';
import { useUserStore } from '@/stores/user.store';
import helpers from '@/helpers';
import useTranslations from '@/composables/useTranslations';
import { computed, onMounted, ref } from 'vue';
import { Tooltip as KTooltip } from '@progress/kendo-vue-tooltip';
import UserAvatar from '@/components/common/userAvatar/UserAvatar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileMenu',
  props: {
  isOpen: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const appStore = useAppStore();
const userStore = useUserStore();
const { translate: t } = useTranslations();
const menuItems = ref<HTMLElement[]>([]);

const props = __props;

onMounted(() => {
  if (props.isOpen) {
    menuItems.value[0].focus();
  }
});

const userIsGuest = computed(() => {
  return userStore.userIsGuest;
});

function link(path: string) {
  return helpers.url.outerUrl(path);
}

function setMenuItem(el: HTMLElement | null) {
  if (el) {
    menuItems.value.push(el);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KTooltip), {
    "open-delay": 0,
    "parent-title": true,
    position: 'top'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([{ mobile: _unref(appStore)?.isMobile }, "user-profile-menu"]),
        role: "menu"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(UserAvatar, {
            "avatar-id": _unref(userStore).userSettings.avatarId
          }, null, 8, ["avatar-id"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(userStore)?.userSettings?.displayName), 1),
            (!userIsGuest.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  title: _unref(userStore)?.userSettings?.email,
                  class: "user-profile-menu__user-email"
                }, [
                  _createElementVNode("div", null, _toDisplayString(_unref(userStore)?.userSettings?.email), 1)
                ], 8, _hoisted_4))
              : _createCommentVNode("", true)
          ])
        ]),
        (!userIsGuest.value)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (!userIsGuest.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_unref(appStore)?.systemSettings?.userNavigationProfileVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("a", {
                        ref: 
                (el) => {
                  setMenuItem(el as HTMLElement);
                }
              ,
                        href: link('/account/details'),
                        "data-testid": "user-profile-menu__my-profile",
                        role: "menuitem",
                        tabindex: "0"
                      }, _toDisplayString(_unref(t)('Usr.MyProfileTitle')), 9, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(appStore)?.systemSettings?.userNavigationIdeasVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("a", {
                        ref: 
                (el) => {
                  setMenuItem(el as HTMLElement);
                }
              ,
                        href: link('/ideamanagement/myideaslist'),
                        "data-testid": "user-profile-menu__my-items",
                        role: "menuitem",
                        tabindex: "0"
                      }, _toDisplayString(_unref(appStore)?.systemSettings?.myItemsTexts[_unref(appStore)?.cultureCode]), 9, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(appStore)?.systemSettings?.userNavigationTasksVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("a", {
                          ref: 
                  (el) => {
                    setMenuItem(el as HTMLElement);
                  }
                ,
                          href: link('/tasks/mytasks'),
                          "data-testid": "user-profile-menu__my-tasks",
                          role: "menuitem",
                          tabindex: "0"
                        }, _toDisplayString(_unref(t)('Task.MyTasks')), 9, _hoisted_14),
                        (_unref(userStore)?.userSettings?.hasNotifications)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(appStore)?.systemSettings?.userNavigationClosedCompetitionVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("a", {
                        ref: 
                (el) => {
                  setMenuItem(el as HTMLElement);
                }
              ,
                        href: link('/study/myachievements'),
                        role: "menuitem",
                        tabindex: "0"
                      }, _toDisplayString(_unref(t)('MyAchievements')), 9, _hoisted_17)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_18, [
            (!userIsGuest.value && _unref(appStore)?.systemSettings?.userNavigationSettingsVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("a", {
                    ref: 
                (el) => {
                  setMenuItem(el as HTMLElement);
                }
              ,
                    href: link('/account/settings'),
                    role: "menuitem",
                    tabindex: "0"
                  }, _toDisplayString(_unref(t)('Menu.MySettings')), 9, _hoisted_20)
                ]))
              : _createCommentVNode("", true),
            (_unref(userStore).userSettings.isAdministrationAreaAvailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("a", {
                    ref: 
                (el) => {
                  setMenuItem(el as HTMLElement);
                }
              ,
                    href: link('/administration'),
                    "data-testid": "user-profile-menu__admin",
                    role: "menuitem",
                    tabindex: "0"
                  }, _toDisplayString(_unref(t)('Common.AdminArea')), 9, _hoisted_22)
                ]))
              : _createCommentVNode("", true),
            (!userIsGuest.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("form", _hoisted_24, [
                    _createElementVNode("button", _hoisted_25, _toDisplayString(_unref(t)('Logout')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (userIsGuest.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("a", {
                    ref: 
                (el) => {
                  setMenuItem(el as HTMLElement);
                }
              ,
                    href: link('/login'),
                    role: "menuitem",
                    tabindex: "0"
                  }, _toDisplayString(_unref(t)('Login.LeadText')) + " " + _toDisplayString(_unref(t)('Or')) + " " + _toDisplayString(_unref(t)('Register')), 9, _hoisted_27)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})